<script>
    export let classes = [];
    export let selectedClasses = [];
    import { formatEuroAmount } from './money.js';
  
    function toggleSequential(id) {
      // Only allow selection for partially_paid or unpaid classes
      const selectableClasses = classes.filter(c => c.status === 'partially_paid' || c.status === 'unpaid');
      const selectableIds = selectableClasses.map(c => c.id);
      const index = selectableIds.indexOf(id);
      const isSelected = selectedClasses.includes(id);
  
      if (!selectableIds.includes(id)) return; // Prevent toggling fully paid classes
  
      if (isSelected) {
        selectedClasses = selectableClasses
          .slice(0, index)
          .filter(c => selectedClasses.includes(c.id))
          .map(c => c.id);
      } else {
        selectedClasses = selectableClasses
          .slice(0, index + 1)
          .map(c => c.id);
      }
    }
  
    function formatDate(dateStr) {
      const date = new Date(dateStr);
      return date.toLocaleString('lt-LT', {
        weekday: 'short',
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    }
  
    function formatTeacherName(fullName) {
      // Remove 'Tutory' if present at the end
      let name = fullName.replace(/\s*Tutory$/, '').trim();
      const parts = name.split(' ');
      if (parts.length >= 2) {
        // First name and last name
        return `${parts[0]} ${parts[1][0]}.`;
      } else if (parts.length === 1) {
        return parts[0];
      } else {
        return fullName;
      }
    }
  </script>
  
    <!-- 
      Class selection UI:
      - c.status: UI simulation showing payment status for ALL classes (including future ones)
      - c.has_class_charge: Real indicator showing which past classes have actual charges
      - Selection is disabled only for 'paid' classes (regardless of past/future)
    -->
    <div class="checkbox-area">
    {#each classes as c}
      <label 
        class:selected={selectedClasses.includes(c.id)} 
        class:disabled={c.status === 'paid'}
        class:has-debt={c.has_class_charge}
      >
        <div class="checkbox-container">
          <input
            type="checkbox"
            checked={selectedClasses.includes(c.id)}
            disabled={c.status === 'paid'}
            on:change={() => toggleSequential(c.id)}
          />
        </div>

        <div class="content">
          <div class="left">
            <div class="date">{formatDate(c.start_time)}</div>
            <div class="info">{c.name}</div>
            {#if c.cancelled_payable}
              <span class="cancelled-payable-label">Ne laiku atšaukta</span>
            {/if}
            <div class="teacher">{formatTeacherName(c.teacher)}</div>
          </div>
          <div class="right">
            <div class="price-block">
              <div class="original-price">Kaina: €{formatEuroAmount(c.price)}</div>
              {#if c.status === 'paid'}
                <div class="paid-status">Apmokėta</div>
              {:else if c.status === 'partially_paid'}
                <div class="to-pay">Mokėti: €{Math.round(parseFloat(c.amount_due) || 0)}</div>
                <div class="partial-status">(dalinai apmokėta)</div>
              {:else}
                <div class="to-pay">Mokėti: €{Math.round(parseFloat(c.amount_due) || 0)}</div>
              {/if}
            </div>
          </div>
        </div>
      </label>
    {/each}
  </div>
  
  <style>
    .cancelled-payable-label {
      color: #9b4039;
      font-size: 0.8rem;
      font-weight: 600;
      line-height: 1.4;
    }
    .checkbox-area {
      display: flex;
      flex-direction: column;
      gap: 0.75rem;
      width: 100%;
    }
  
    label {
      padding: 0.75rem 1rem;
      border: 1px solid #ddd;
      border-radius: 8px;
      transition: background-color 0.2s ease, border-color 0.2s ease;
      display: flex;
      gap: 0.75rem;
      align-items: center;
      cursor: pointer;
    }
  
    label.selected {
      background-color: #eef6ff;
      border-color: #3b82f6;
    }
  
    label.disabled {
      opacity: 0.5;
      pointer-events: none;
    }

    label.has-debt {
      background-color: #fef2f2;
      border-color: #fca5a5;
    }

    label.has-debt.selected {
      background-color: #feebc8;
      border-color: #f6ad55;
    }
  
    .checkbox-container {
      display: flex;
      align-items: center;
    }
  
    input[type="checkbox"] {
      transform: scale(1.5);
      accent-color: #3b82f6;
    }
  
    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex: 1;
      gap: 1rem;
    }
  
    .left {
      display: flex;
      flex-direction: column;
      gap: 0.1rem;
    }
  
    .date {
      font-weight: 600;
      font-size: 0.95rem;
    }
  
    .info {
      font-size: 0.9rem;
    }
  
    .teacher {
      font-size: 0.85rem;
      color: #666;
    }
  
    .right {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-size: 1rem;
      font-weight: normal;
      white-space: nowrap;
      min-width: 60px;
    }
  
    .price-block {
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      font-size: 0.98rem;
      gap: 0.1em;
    }
  
    .original-price {
      font-size: 0.95rem;
      color: #888;
    }
  
    .to-pay {
      font-size: 1.05rem;
      font-weight: bold;
      color: #14695b;
    }
  
    .paid-status {
      font-size: 1.05rem;
      font-weight: bold;
      color: #3b82f6;
    }
  
    .partial-status {
      font-size: 0.95rem;
      color: #e67e22;
    }
  </style>
